module.exports = __webpack_public_path__ + "static/helga-butcher-c5eeb9453782e8f1839cf9fce0031d56.png";